export const GOOGLE_MAPS_API = "AIzaSyB0MC4rwg9kymIy-coTeC9TSKDr-pbhje0";
export const UW_TACOMA_GEOLOCATION = {
  Latitude: 47.24560815971,
  Longitude: -122.43850536339994
}
